export function StatusPill({ source, count }: { source?: string; count?: number }) {
  return (
    <span className="hidden items-center gap-2 rounded-full border border-brand-100 bg-white/80 px-3 py-2 text-xs font-bold text-slate-600 shadow-sm md:inline-flex">
      <i className={`h-2 w-2 rounded-full ${source === 'live' ? 'bg-brand-500' : 'bg-amber-400'}`} />
      {source === 'live' ? 'Live workbook' : source === 'fallback' ? 'Local snapshot' : 'Loading data'}
      {typeof count === 'number' ? ` · ${count} programs` : ''}
    </span>
  );
}
